import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import GenericTemplateTemplate from './GenericTemplateTemplate'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon

export default class GenericTemplateComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.GENERIC_TEMPLATE)

    this.socket = config ? config.sockets : null
    this.data.component = GenericTemplateTemplate
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
  }

  builder(node) {
    node.lingualName = lingualName.GENERIC_TEMPLATE
    this.setConnection()
    
    const genericTemplateInput = new Rete.Input(
      CONST_SOCKET.GENERIC_TEMPLATE_INPUT, 
      lang.generic_template_socket_input_reply, 
      this.socket.genericTemplateInput,
      true
    )
    
    const genericTemplateOutput = new Rete.Output(
      CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT, 
      lang.generic_template_socket_output_next, 
      this.socket.genericTemplateOutput, 
      false
    )
    
    const genericTemplateOutputButton = new Rete.Output(
      CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_BUTTON, 
      lang.generic_template_socket_output_buttons, 
      this.socket.genericTemplateOutputButton, 
      true
    )

    const genericTemplateOutputQuickreply = new Rete.Output(
      CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_QUICKREPLY, 
      lang.generic_template_socket_output_quick_replies, 
      this.socket.genericTemplateOutputQuickreply, 
      true
    )

    node.addInput(genericTemplateInput)
    node.addOutput(genericTemplateOutput)
    node.addOutput(genericTemplateOutputButton)

    if (! instagram_addon) {
      node.addOutput(genericTemplateOutputQuickreply)
    }

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_BUTTON] = node.data
  }
  
  setConnection() {
    // GenericTemplate may take connections from:
    this.socket.genericTemplateInput.combineWith(this.socket.referenceOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.newPostbackOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.textOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.carouselOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.facebookMediaOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.imageOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.videoOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.audioOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.fileOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.ecommerceOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.genericTemplateOutput)
    this.socket.genericTemplateInput.combineWith(this.socket.otnOutput)

    // GenericTemplate may be connected to:
    this.socket.genericTemplateOutput.combineWith(this.socket.textInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.carouselInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.facebookMediaInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.imageInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.videoInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.audioInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.fileInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.ecommerceInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.genericTemplateOutput.combineWith(this.socket.componentListInput)

    this.socket.genericTemplateOutput.combineWith(this.socket.otnInput)
    
    if (this.isUserInputFlowAddonAvailable) {
      this.socket.genericTemplateOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (Buttons): Buttons, QuickReply
    this.socket.genericTemplateOutputButton.combineWith(this.socket.buttonInput)
    this.socket.genericTemplateOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}